// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueAnalytics from 'vue-analytics'
import {httpClient} from './config/httpclient.js'
import VueHtmlToPaper from 'vue-html-to-paper';


import { MdButton, MdCard, MdTabs, MdDialog,MdDialogAlert, MdMenu,
  MdDialogConfirm,MdDialogPrompt, MdField, MdRadio, MdProgress, MdList,
   MdIcon, MdSnackbar } from 'vue-material/dist/components'

   const options = {
    name: '_blank',
    specs: [
      'fullscreen=yes',
      'titlebar=yes',
      'scrollbars=yes'
    ],
    styles: [
      'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
      'https://unpkg.com/kidlat-css/css/kidlat.css'
    ]
  }   

Vue.use(VueHtmlToPaper, options);

 Vue.use(VueAnalytics, {
  id: 'UA-137364535-2',
  router
})

// Vue.use(VueMaterial);
Vue.use(MdButton);
Vue.use(MdCard);
Vue.use(MdTabs);
Vue.use(MdDialog);
Vue.use(MdDialogAlert);
Vue.use(MdDialogConfirm);
Vue.use(MdDialogPrompt);
Vue.use(MdField);
Vue.use(MdRadio);
Vue.use(MdProgress);
Vue.use(MdIcon);
Vue.use(MdMenu);
Vue.use(MdList);
Vue.use(MdSnackbar);


//global axios config
Vue.prototype.$http = httpClient;


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js